import {
  TCrmGranularity,
  TCrmSchoolStatus,
  TCrmSignal,
  TCrmStatus,
} from '../../../shared/common/api/endpoints/crmAnalyticsApi';

// Первая школа подключена 18.06.2021 — начало периода «За всё время»
export const FIRST_DAY = '2021-06-01';

export type TRevenueMode = 'cash' | 'accrual';

export interface TStatusMeta {
  label: string;
  color: string;
  hint: string;
}

// Порядок в стопке графика = порядок слотов палитры: проверено валидатором на различимость
// соседних цветов (в том числе при дальтонизме). Цвет закреплён за статусом, а не за местом.
export const STATUS_ORDER: TCrmStatus[] = [ 'paying', 'debt', 'test', 'grace_alive', 'suspended', 'grace_dead' ];

export const STATUS_META: Record<TCrmSchoolStatus, TStatusMeta> = {
  paying: {
    label: 'Платят',
    color: '#2a78d6',
    hint: 'Оплаченный доступ: в этот день было списание за сервис',
  },
  debt: {
    label: 'В долгу',
    color: '#eb6834',
    hint: 'Доступ открыт в долг, требуется оплата',
  },
  test: {
    label: 'Тест',
    color: '#1baf7a',
    hint: 'Тестовый доступ, 14 дней с подключения',
  },
  grace_alive: {
    label: 'Льготные',
    color: '#eda100',
    hint: 'Выручка школы за 30 дней меньше 100 тыс. ₽ — доступ бесплатный',
  },
  suspended: {
    label: 'Приостановлены',
    color: '#e87ba4',
    hint: 'Выручка школы выше 100 тыс. ₽, но денег на балансе нет',
  },
  grace_dead: {
    label: 'Неживые льготные',
    color: '#b4b2a9',
    hint: 'Льготный доступ без выручки за 30 дней — школа фактически не работает',
  },
  disconnected: {
    label: 'Отключена',
    color: '#d9d9d9',
    hint: 'Школа отключена в сервисе',
  },
};

export const SIGNAL_META: Record<TCrmSignal, { label: string; color: string; hint: string }> = {
  debt: {
    label: 'В долгу',
    color: 'orange',
    hint: 'Доступ открыт в долг',
  },
  balance_low: {
    label: 'Баланс на исходе',
    color: 'gold',
    hint: 'Платит, но денег осталось на 7 дней и меньше',
  },
  no_activity: {
    label: 'Не заходят',
    color: 'purple',
    hint: 'Платит, но в кабинет не заходили больше 14 дней',
  },
  stopped_paying: {
    label: 'Перестала платить',
    color: 'red',
    hint: 'Приостановлена, оплаченный доступ закончился меньше 30 дней назад — ещё можно вернуть',
  },
  works_not_paying: {
    label: 'Работает, не платит',
    color: 'magenta',
    hint: 'Приостановлена дольше 30 дней: выручка выше 100 тыс. ₽, данные из GetCourse приходят, денег нет',
  },
};

export const GRANULARITY_OPTIONS: { label: string; value: TCrmGranularity }[] = [
  { label: 'Дни', value: 'day' },
  { label: 'Недели', value: 'week' },
  { label: 'Месяцы', value: 'month' },
  { label: 'Кварталы', value: 'quarter' },
  { label: 'Годы', value: 'year' },
];

// Цвета графиков: слоты проверенной палитры, оси и сетка — приглушённые
export const CHART_COLORS = {
  primary: '#2a78d6',
  secondary: '#eb6834',
  tertiary: '#1baf7a',
  commission: '#6250d6',
  gain: '#2a78d6',
  gainLight: '#86b6ef',
  loss: '#e34948',
  // Окна конверсии 14 / 30 / 90 дней — одна шкала синего от светлого к тёмному
  windows: [ '#86b6ef', '#3987e5', '#1c5cab' ],
  surface: '#ffffff',
  axisText: '#8c8c8c',
  axisLine: '#d9d9d9',
  gridLine: '#f0f0f0',
  tooltipText: '#262626',
  tooltipMuted: '#8c8c8c',
};
